module.exports = __webpack_public_path__ + "static/media/nexus.8e9db78c.jpg";